webpackJsonp([35783957827783],{

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(3);
	
	var _marketing = __webpack_require__(8);
	
	var _utils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Home = function (_React$Component) {
	  _inherits(Home, _React$Component);
	
	  function Home(props) {
	    _classCallCheck(this, Home);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Home.prototype.componentDidMount = function componentDidMount() {
	    (0, _utils.seoPageChange)();
	  };
	
	  Home.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'HomePage' },
	      _react2.default.createElement(_components.StripeBG, { bg2: "white" }),
	      _react2.default.createElement(_marketing.Navbar, { className: 'grid-restrain' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'top-desc grid-row grid-column grid-restrain v-align h-align s30 full-7 full-s20' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Spend less time on browser tests.'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          'SnapTest is a browser extension for fast, light-weight, and scalable browser tests & macros.'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'grid-row grid-restrain s10 full-7 full-s20' },
	        _react2.default.createElement(
	          'div',
	          { className: 'grid-item-3 sr4 full-s10 full-s7' },
	          _react2.default.createElement(
	            'div',
	            { className: 'grid-item-4 video-cont full-s10' },
	            _react2.default.createElement(
	              'div',
	              { className: 'videoWrapper' },
	              _react2.default.createElement('iframe', { width: '560', height: '315', src: 'https://www.youtube.com/embed/TrcuJxZIe38??theme=light&modestbranding=1&autohide=1&showinfo=0&controls=0', frameBorder: '0', allowFullScreen: '' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'grid-item-2 grid-row grid-column v-align h-align' },
	          _react2.default.createElement(
	            'a',
	            { className: 'cta-primary s2', href: 'https://chrome.google.com/webstore/detail/snaptest/aeofjocnhdlleichkjbaibdbicpcddhp', target: '_blank' },
	            '+ Get the chrome extension'
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'cta-secondary',
	              onClick: function onClick() {
	                return window.open("https://www.reddit.com/r/programming/comments/6mgvgq/made_a_selenium_idelike_chrome_extension_that_can/?st=jfn3oh5w&sh=5235ba44");
	              } },
	            '+ What does Reddit think of SnapTest?'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'cute-link' },
	            _react2.default.createElement(
	              _components.Link,
	              { to: "/updates" },
	              'We are making progress fast. Check it out.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'product-hero grid-restrain grid-row v-align h-align full-10' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h1',
	            { className: 's6 grid-row h-align' },
	            'Lightweight & Scalable!'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'description s6' },
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Create and maintain your tests quickly with the best test recorder around.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Scale using components, variables, environments, run configurations, tags, and more...'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Fits any team size - team collaboration features.'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'snapshots text-center' },
	        _react2.default.createElement(
	          'div',
	          { className: 'grid-restrain grid-row grid-column full-8' },
	          _react2.default.createElement(
	            'div',
	            { className: 'grid-row full-8' },
	            _react2.default.createElement(
	              'div',
	              { className: 'grid-item' },
	              _react2.default.createElement(
	                'a',
	                { href: 'https://res.cloudinary.com/snaptest/image/upload/v1530677595/marketing/Screen_Shot_2018-07-03_at_11.13.05_PM.png', target: '_blank' },
	                _react2.default.createElement('img', { className: 'snapshot card', src: 'https://res.cloudinary.com/snaptest/image/upload/v1530677595/marketing/Screen_Shot_2018-07-03_at_11.13.05_PM.png' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'grid-item' },
	              _react2.default.createElement(
	                'a',
	                { href: 'https://res.cloudinary.com/snaptest/image/upload/v1530677871/marketing/Screen_Shot_2018-07-03_at_11.17.26_PM.png', target: '_blank' },
	                _react2.default.createElement('img', { className: 'snapshot card', src: 'https://res.cloudinary.com/snaptest/image/upload/v1530677871/marketing/Screen_Shot_2018-07-03_at_11.17.26_PM.png' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'grid-row full-8' },
	            _react2.default.createElement(
	              'div',
	              { className: 'grid-item' },
	              _react2.default.createElement(
	                'a',
	                { href: 'https://res.cloudinary.com/snaptest/image/upload/v1530679015/marketing/Screen_Shot_2018-07-03_at_11.36.35_PM.png', target: '_blank' },
	                _react2.default.createElement('img', { className: 'snapshot card', src: 'https://res.cloudinary.com/snaptest/image/upload/v1530679015/marketing/Screen_Shot_2018-07-03_at_11.36.35_PM.png' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'grid-item' },
	              _react2.default.createElement(
	                'a',
	                { href: 'https://res.cloudinary.com/snaptest/image/upload/v1530679075/marketing/generate.png', target: '_blank' },
	                _react2.default.createElement('img', { className: 'snapshot card', src: 'https://res.cloudinary.com/snaptest/image/upload/v1530679075/marketing/generate.png' })
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_marketing.Footer, null)
	    );
	  };
	
	  return Home;
	}(_react2.default.Component);
	
	exports.default = Home;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-f80ad65dfa9ab396da53.js